import { render, staticRenderFns } from "./NewPolicy_new.vue?vue&type=template&id=2dcf4e4a&"
import script from "./NewPolicy_new.vue?vue&type=script&lang=js&"
export * from "./NewPolicy_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports